import {createApi, fetchBaseQuery} from "@reduxjs/toolkit/query/react";

export const readyForPickupApi = createApi({
  reducerPath: "readyForPickupApi",
  baseQuery: fetchBaseQuery({baseUrl: process.env.BEMAKERS_API_URL}),
  endpoints: (build) => ({
    getReadyForPickupOrder: build.query({
      query: (token) => ({
        url: `/ready_for_pickup/${token}`,
        method: "GET",
      }),
    }),
    confirmReadyForPickupOrder: build.mutation({
      query: (token) => ({
        url: `/ready_for_pickup/${token}`,
        method: "PUT",
      }),
    }),
  }),
});

export const {useGetReadyForPickupOrderQuery, useConfirmReadyForPickupOrderMutation} = readyForPickupApi;
